<header>
  <div class="header-container container d-flex align-items-center h-100">
        <div class="header-content d-flex flex-column">
            <p class="text-highlighted">Dale a tus pacientes la</p>
            <p class="text-big">libertad de sonre&iacute;r</p>
            <p class="text-middle">al m&aacute;ximo todos los d&iacute;as</p>
        </div>
    </div>
</header>
